var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdible = function SvgEdible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061E21",
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2q.578 0 1.14.064a1 1 0 0 1 .88 1.119 2.5 2.5 0 0 0 2.144 2.795 1 1 0 0 1 .858.858 2.5 2.5 0 0 0 3.352 2.007 1 1 0 0 1 1.32.691c.2.79.306 1.616.306 2.466 0 5.523-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 7.936 6.98 4.501 4.501 0 0 1-4.743-3.172 4.5 4.5 0 0 1-3.165-3.808z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#061E21",
    d: "M10 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M14 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M18 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
export default SvgEdible;